import React, { useState, useEffect, useContext } from "react";
import "./login.css";
import { Link, withRouter, useLocation } from "react-router-dom";
import {
  Input,
  message,
  Form,
  Icon,
  Button,
  Row,
  Col,
  notification,
  Alert,
} from "antd";
import logoLS from "../../assets/logo/linksight-logo.svg";
import { getToken } from "../../utils/utils";
import { RootContext } from "../../RootContextProvider";
import { verticalFormLayout } from "../../utils/forms";
import { signin } from "../../utils/auth";
import qs from "query-string";
import { verifyEmail } from "../../utils/auth";

export const Login = (props) => {
  const location = useLocation();
  const { history } = props;

  const [isLoading, setIsLoading] = useState(false);
  const [displayError, setDisplayError] = useState(false);
  const { setToken } = useContext(RootContext);

  useEffect(() => {
    // const getSigninMethod = async () => {
    //   const param = await extractParams(props);
    //   if (param) {
    //     if (param.method === "login") {
    //       // window.analytics.track('login-google')
    //     } else if (param.method === "signup") {
    //       // window.analytics.track('signup-google')
    //     }
    //   }
    // };
    // getSigninMethod().then(() => {
    const getUserToken = async () => {
      await getToken(props, setToken);
    };
    const parseURL = async () => {
      const id = qs.parse(location.search);
      console.log(id);
      if (Object.entries(id).length !== 0) {
        // API CALL TO ENDPOINTS TO VALIDATE EMAIL
        await confirmEmail(id.id);
      }
    };

    getUserToken();
    parseURL();
    // eslint-disable-next-line
  }, []);

  const onFinish = async (values) => {
    setIsLoading(true);
    try {
      const cb = await signin(values.email.toLowerCase(), values.password);
      console.log(cb);

      if (cb.err === "Please confirm your email.") {
        console.debug("Validation needed, reloading...");
        history.push("/validation");
      } else if (!cb.token) {
        setDisplayError(true);
      } else {
        setToken(cb.token, true);
      }
    } catch (err) {
      console.error(err);
      message.error(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  const onFinishFailed = () => {
    console.log("it failed");
  };

  const openNotificationWithIcon = (type) => {
    if (type === "success") {
      notification[type]({
        message: "Compte validé",
        description:
          " Votre compte est bien validé. Connectez-vous dès maintenant.",
      });
    } else {
      notification[type]({
        message: "Votre compte n'est pas validé.",
        description: "Oh-oh! Nous n'avons pas réussi à vérifier votre compte.",
      });
    }
  };

  const confirmEmail = async (id) => {
    const verification = await verifyEmail(id);
    if (verification === true) {
      openNotificationWithIcon("success");
    } else {
      openNotificationWithIcon("error");
    }
  };

  return (
    <div className="signin-container">
      <Row>
        <Col xl={8} lg={8} md={24} sm={24} xs={24}>
          <div className="block-signin">
            <div className="heading-auth">
              <div className="logo-ls">
                <img src={logoLS} alt="logo linksight" width="190px" />
              </div>
              <span>Nous sommes ravis de vous revoir</span>
            </div>
            {/* <div className="signin-google">
          <a href="http://localhost:4000/auth/google">
            <button type="button" className="google-login">
              <img src={googleSvg} alt="logo google" />
              <span>Se connecter avec Google</span>
            </button>
          </a>
        </div> */}
            <div className="signin-local">
              <Form
                className="form-signup align-left"
                layout="vertical"
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                {...verticalFormLayout}
              >
                <Form.Item
                  label="Email"
                  name="email"
                  rules={[{ required: true, message: "Insérez votre email" }]}
                >
                  <Input className="auth-input" placeholder="Elon@tesla.com" />
                </Form.Item>

                <Form.Item
                  label="Mot de passe"
                  name="password"
                  rules={[
                    { required: true, message: "Insérez votre mot de passe" },
                  ]}
                >
                  <Input
                    className="auth-input"
                    placeholder="*********"
                    type="password"
                  />
                </Form.Item>
                {displayError ? (
                  <Alert
                    type="error"
                    message="Email ou mot de passe invalide"
                    showIcon
                  />
                ) : (
                  ""
                )}
                <Form.Item>
                  <div className="forgot">
                    <Link to="/forgot-password">Mot de passe oublié ?</Link>
                  </div>

                  <Button
                    className="signup-button"
                    type="secondary"
                    htmlType="submit"
                    loading={isLoading}
                    size="large"
                  >
                    Connexion <Icon type="arrow-right" />
                  </Button>
                </Form.Item>
              </Form>
            </div>
            <div className="signup-link">
              <span>
                Vous n'avez pas encore de compte ?{" "}
                <Link to="/signup">S'inscrire maintenant !</Link>
              </span>
            </div>
          </div>
        </Col>
        <Col
          xl={16}
          lg={16}
          md={24}
          sm={24}
          xs={24}
          className="block-image"
        ></Col>
      </Row>
    </div>
  );
};

export default withRouter(Login);
